const roleAliases = {
  leader: 'road_captain',
  participant: 'member',
};

const roleDefinitions = {
  organizer: { label: 'Organizer', tone: 'organizer', priority: 5 },
  road_captain: { label: 'Road Captain', tone: 'leader', priority: 5 },
  club_captain: { label: 'Club Captain', tone: 'captain', priority: 4 },
  sub_convoy_leader: { label: 'Sub-Convoy Leader', tone: 'subleader', priority: 4 },
  sweeper: { label: 'Sweeper', tone: 'sweeper', priority: 5 },
  medic: { label: 'Medic', tone: 'medic', priority: 4 },
  mechanic: { label: 'Mechanic', tone: 'mechanic', priority: 4 },
  marshal: { label: 'Marshal', tone: 'marshal', priority: 4 },
  guest: { label: 'Guest Rider', tone: 'guest', priority: 2 },
  member: { label: 'Rider', tone: 'member', priority: 1 },
};

const glyphs = {
  organizer: '<svg viewBox="0 0 24 24"><path d="m4 8 4 4 4-7 4 7 4-4-2 11H6L4 8Z"/><path d="M7 19h10"/></svg>',
  road_captain: '<svg viewBox="0 0 24 24"><path d="M6 3v18M7 4h11l-3 4 3 4H7"/><path d="m3 8-2 4 2 4M21 8l2 4-2 4"/></svg>',
  club_captain: '<svg viewBox="0 0 24 24"><path d="m5 14 7-5 7 5M5 20l7-5 7 5"/></svg>',
  sub_convoy_leader: '<svg viewBox="0 0 24 24"><path d="m12 2 8 18-8-4-8 4 8-18Z"/><path d="M12 7v7"/></svg>',
  sweeper: '<svg viewBox="0 0 24 24"><path d="M12 3 19 6v5c0 4.6-2.8 8-7 10-4.2-2-7-5.4-7-10V6l7-3Z"/><path d="m9 12 2 2 4-5"/></svg>',
  member: '<svg viewBox="0 0 24 24"><circle cx="7" cy="17" r="3"/><circle cx="18" cy="17" r="3"/><path d="m7 17 4-6h4l3 6M10 11l-2-2M14 11l3-3"/></svg>',
  medic: '<svg viewBox="0 0 24 24"><path d="M12 3 19 6v5c0 4.6-2.8 8-7 10-4.2-2-7-5.4-7-10V6l7-3Z"/><path d="M12 8v7M8.5 11.5h7"/></svg>',
  mechanic: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/></svg>',
  marshal: '<svg viewBox="0 0 24 24"><path d="m5 19 14-14M5 5l14 14"/><path d="M8 4h8M8 20h8"/></svg>',
  guest: '<svg viewBox="0 0 24 24"><path d="m12 3 2.7 5.6 6.3.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.5l6.3-.9L12 3Z"/></svg>',
  warning: '<svg viewBox="0 0 24 24"><path d="M12 3 22 20H2L12 3Z"/><path d="M12 9v5M12 17h.01"/></svg>',
  offline: '<svg viewBox="0 0 24 24"><path d="m12 3 9 9-9 9-9-9 9-9Z"/><path d="m8 8 8 8"/></svg>',
};

export const clubPalette = ['#42e8e0', '#a78bfa', '#f4b942', '#fb7185', '#34d399', '#60a5fa'];
export const clubPatterns = ['solid', 'double', 'segmented', 'dashed'];

export function normalizedRideRole(value) {
  const role = String(value || 'member').toLowerCase();
  return roleAliases[role] || (roleDefinitions[role] ? role : 'member');
}

export function roleIdentity(role) {
  const normalized = normalizedRideRole(role);
  return { key: normalized, ...roleDefinitions[normalized], glyph: glyphs[normalized] || glyphs.member };
}

export function markerState(properties) {
  if (properties.rideStatus === 'sos' || properties.rideStatus === 'emergency' || properties.connectivityStage === 'emergency_active') return 'critical';
  if (properties.connectivityStage === 'emergency_suspected' || properties.connectivityStage === 'reconnecting') return 'warning';
  if (properties.rideStatus === 'offline' || properties.connectivityStage === 'signal_weak') return 'offline';
  if (properties.safeConfirmed === true) return 'safe';
  if (properties.isSpeaking === true) return 'speaking';
  return 'normal';
}

export function clubIdentity(clubId, custom = {}) {
  const value = String(clubId || 'guest');
  let hash = 0;
  for (let index = 0; index < value.length; index += 1) hash = ((hash << 5) - hash + value.charCodeAt(index)) | 0;
  const color = custom.color || clubPalette[Math.abs(hash) % clubPalette.length];
  const pattern = custom.pattern || clubPatterns[Math.abs(hash) % clubPatterns.length];
  return { color, pattern };
}

export function markerVisual(properties, customIdentity = {}) {
  const role = roleIdentity(properties.rideRole);
  const state = markerState(properties);
  const club = clubIdentity(properties.clubId, customIdentity);
  const stateGlyph = state === 'critical' || state === 'warning' ? glyphs.warning : state === 'offline' ? glyphs.offline : role.glyph;
  return { role, state, club, glyph: stateGlyph };
}
